/**
 * Storage-warning banners.
 *
 * Two banner variants share DOM shape but differ in copy + variant class:
 *   - mountPrivateBrowsingBanner(): shown at boot when the storage
 *     sentinel write throws. Tells the user lists won't be saved.
 *   - mountMigrationFailureBanner(): shown at boot when migrate()
 *     returns { success: false }. Tells the user a backup was preserved.
 *
 * Both are role=alert + aria-live=assertive so VoiceOver announces
 * them immediately on app open. Both are user-dismissable via an X.
 * Both are idempotent.
 *
 * Signatures match the Batch 2 stubs in src/ui/modal-stubs.js.
 */

function mountWarning({ id, variant, message }) {
  if (document.getElementById(id)) return;

  const banner = document.createElement('div');
  banner.id = id;
  banner.className = `storage-warning ${variant}`;
  banner.setAttribute('role', 'alert');
  banner.setAttribute('aria-live', 'assertive');
  banner.innerHTML = `
    <span class="storage-warning__text">${message}</span>
    <button type="button" class="storage-warning__close" data-action="close"
            aria-label="Close">
      <span aria-hidden="true">\u00D7</span>
    </button>
  `;

  banner.querySelector('[data-action="close"]').addEventListener('click', () => {
    if (banner.parentNode) banner.parentNode.removeChild(banner);
  });

  document.body.appendChild(banner);
}

export function mountPrivateBrowsingBanner() {
  mountWarning({
    id: 'storage-warning-private',
    variant: 'storage-warning--private',
    message: "Private browsing detected — your lists won't be saved. Open in a regular tab to use this app."
  });
}

export function mountMigrationFailureBanner() {
  mountWarning({
    id: 'storage-warning-migration',
    variant: 'storage-warning--migration',
    message: 'Could not read saved lists. A backup was preserved for recovery.'
  });
}
